import { Alert, Modal } from "antd";
import { ReactNode, useEffect } from "react";
import { DataFormContext, useDataForm } from "./DataForm";
import { EditableProps, EditableWithButtonsLayout } from "./Editable";

export const DataFormWithButtonsLayout = function (props: {
    editableProps: EditableProps<any>,
    saveAndStay?: boolean
    children: ReactNode,
}) {
    const { editableProps } = props;

    const [form] = useDataForm();

    const onSaveClick = () => {
        form.validateFields().then(() => {
            editableProps.save();
        }).catch(() => {});
    };

    const onSaveAndStayClick = () => {
        form.validateFields().then(() => {
            editableProps.saveAndStay();
        }).catch(() => {});
    };

    useEffect(() => {
        let formErrors = editableProps.error && editableProps.error.errors;
        if (formErrors) {
            for (let key in formErrors) {
                form.setFields([
                    {
                        name: key,
                        errors: [formErrors[key]],
                    },
                ]);
            }
        } else {
            form.setFields([]);
        }

        if (editableProps.error && editableProps.error.message) {
            Modal.error({ title: 'Error', content: editableProps.error.message });
        }
    }, [editableProps.error]);

    return (
        <DataFormContext.Provider value={form}>
            <EditableWithButtonsLayout
                {...editableProps}
                onSaveAndStayClick={props.saveAndStay ? onSaveAndStayClick : undefined}
                onSaveClick={onSaveClick}
                onDeleteClick={editableProps.remove}
                onCancelClick={editableProps.cancel}
            >
                {/* editableProps.error && <Alert
                    description={editableProps.error.message}
                    type="error"
                    showIcon
                    style={{ marginBottom: '1.5em'}}
                /> */}
                {props.children}
            </EditableWithButtonsLayout>
        </DataFormContext.Provider>
    );

};
